import { ReportAttributes, ReportRelationships } from 'dashboard/models/report';
import { ApiModel, ApiResource } from 'lib/interfaces/api';

export enum ResultStatus {
  PASSED = 'passed',
  FAILED = 'failed',
}

export interface AccountOwnerResult {
  'account-guid'?: string;
  address?: string;
  city?: string;
  country?: string;
  email?: string;
  guid?: string;
  'member-guid'?: string;
  'owner-name'?: string;
  phone?: string;
  'postal-code'?: string;
  state?: string;
  'user-guid'?: string;
  'is-match'?: boolean;
}

export interface ReportMxAccountAttributes extends ReportAttributes {
  query: {
    'user-guid'?: string;
    'member-guid'?: string;
    'name-first'?: string;
    'name-last'?: string;
    'name-middle'?: string;
    'business-name'?: string;
  };
  result?: {
    status?: ResultStatus;
    'account-owner-results': AccountOwnerResult[];
  };
}

export type ReportMxAccount = ApiResource<
  ReportMxAccountAttributes,
  ReportRelationships,
  ApiModel.ReportMxAccount
>;
